import { useCallback, useState } from 'react';

/**
 * 공통 토스트 관리 Hook
 *
 * @returns {{
 *   toastState: { isVisible: boolean, message: string },
 *   showToast: (message: string) => void,
 *   hideToast: () => void,
 *   hasShownToast: boolean,
 *   setHasShownToast: (value: boolean) => void,
 *   resetToast: () => void
 * }}
 */
export default function useToast() {
  const [toastState, setToastState] = useState({
    isVisible: false,
    message: '',
  });

  // 중복 토스트 방지용 (선택적 사용)
  const [hasShownToast, setHasShownToast] = useState(false);

  const showToast = useCallback((message) => {
    setToastState({
      isVisible: true,
      message,
    });
  }, []);

  const hideToast = useCallback(() => {
    setToastState((prev) => ({
      ...prev,
      isVisible: false,
    }));
  }, []);

  const resetToast = useCallback(() => {
    setToastState({ isVisible: false, message: '' });
    setHasShownToast(false);
  }, []);

  return {
    toastState,
    showToast,
    hideToast,
    hasShownToast,
    setHasShownToast,
    resetToast,
  };
}
